export const SET_LAYOUT_CLIENT_HEIGHT = 'SET_LAYOUT_CLIENT_HEIGHT'
export const SET_LAYOUT_CLIENT_WIDTH = 'SET_LAYOUT_CLIENT_WIDTH'
export const SET_LAYOUT_COLLAPSE = 'SET_LAYOUT_COLLAPSE'
export const COLLAPSE_MENU = 'COLLAPSE_MENU'
export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const SET_LOADING_REQUEST_COUNT = 'SET_LOADING_REQUEST_COUNT'
export const OPEN_LOADING = 'OPEN_LOADING'
export const CLOSE_LOADING = 'CLOSE_LOADING'
export const SET_STEP_TEMPLATE_TABLE = 'SET_STEP_TEMPLATE_TABLE'
export const SET_TASK_TEMPLATE = 'SET_TASK_TEMPLATE'

export const SET_USER_TABLE = 'SET_USER_TABLE'
export const SET_USER_PAGINATION = 'SET_USER_PAGINATION'

export const VISIBLE_LAYOUT_EXPORT_DIALOG = 'VISIBLE_LAYOUT_EXPORT_DIALOG'
export const SET_LAYOUT_EXPORT_NAME = 'SET_LAYOUT_EXPORT_NAME'
export const SET_LAYOUT_EXPORT_PERCENTAGE = 'SET_LAYOUT_EXPORT_PERCENTAGE'
export const SET_LAYOUT_EXPORT_STATUS = 'SET_LAYOUT_EXPORT_STATUS'
export const SET_USER_RELATED_OPTIONS = 'SET_USER_RELATED_OPTIONS'
export const SET_USER_OPTIONS = 'SET_USER_OPTIONS'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js